import ConfirmationModal from './ConfirmationModal';
import { forwardRef, memo, useCallback, useState } from 'react';

const ConfirmDialog = memo(
  forwardRef(
    (
      {
        handleYes,
        handleLogout = null,
        onClose = null,
        title = 'Confirmation!',
        content = 'Are you sure you want to call customer?'
      },
      ref
    ) => {
      const [open, setOpen] = useState(false);

      const handleOpen = useCallback(() => setOpen(true), []);
      const handleClose = useCallback(() => {
        onClose && onClose();
        setOpen(false);
      }, [onClose]);

      if (ref) {
        !ref.current && (ref.current = {});
        ref.current.handleOpen = handleOpen;
        ref.current.handleClose = handleClose;
        ref.current.open = open;
      }

      return (
        <ConfirmationModal
          open={open}
          title={title}
          onCancel={handleClose}
          onDecline={() => {
            handleClose();
            handleLogout?.();
          }}
          onConfirm={() => {
            handleClose();
            handleYes();
          }}>
          {content}
        </ConfirmationModal>
      );
    }
  )
);

export default ConfirmDialog;
